import { parse } from 'node-html-parser'

export const useHyphenatedText = (text: string) => {
  const parsed = parse(text).text

  return {
    text: parsed,
    hyphenated: text.includes('&shy;'),
  }
}
